export const TaskActionTypes = {
    LOGOUT: 'LOGOUT',

    ADD_TASK_REQUEST: 'ADD_TASK_REQUEST',
    ADD_TASK_REQUEST_SUCCESS: 'ADD_TASK_REQUEST_SUCCESS',
    ADD_TASK_REQUEST_ERROR: 'ADD_TASK_REQUEST_ERROR',
    ADD_TASK_REQUEST_STATUS: 'ADD_TASK_REQUEST_STATUS',

    TASK_LIST_REQUEST: 'TASK_LIST_REQUEST',
    TASK_LIST_REQUEST_SUCCESS: 'TASK_LIST_REQUEST_SUCCESS',
    TASK_LIST_REQUEST_ERROR: 'TASK_LIST_REQUEST_ERROR',

    TASK_DETAIL_REQUEST: 'TASK_DETAIL_REQUEST',
    TASK_DETAIL_REQUEST_SUCCESS: 'TASK_DETAIL_REQUEST_SUCCESS',
    TASK_DETAIL_REQUEST_ERROR: 'TASK_DETAIL_REQUEST_ERROR',

    UPDATE_TASK_STATUS_REQUEST: 'UPDATE_TASK_STATUS_REQUEST',
    UPDATE_TASK_STATUS_REQUEST_SUCCESS: 'UPDATE_TASK_STATUS_REQUEST_SUCCESS',
    UPDATE_TASK_STATUS_REQUEST_ERROR: 'UPDATE_TASK_STATUS_REQUEST_ERROR',
    UPDATE_TASK_STATUS_REQUEST_STATUS: 'UPDATE_TASK_STATUS_REQUEST_STATUS',

    UPDATE_TASK_DETAIL_REQUEST: 'UPDATE_TASK_DETAIL_REQUEST',
    UPDATE_TASK_DETAIL_REQUEST_SUCCESS: 'UPDATE_TASK_DETAIL_REQUEST_SUCCESS',
    UPDATE_TASK_DETAIL_REQUEST_ERROR: 'UPDATE_TASK_DETAIL_REQUEST_ERROR',
    UPDATE_TASK_DETAIL_REQUEST_STATUS: 'UPDATE_TASK_DETAIL_REQUEST_STATUS',

    ASSIGN_TASK_REQUEST: 'ASSIGN_TASK_REQUEST',
    ASSIGN_TASK_REQUEST_SUCCESS: 'ASSIGN_TASK_REQUEST_SUCCESS',
    ASSIGN_TASK_REQUEST_ERROR: 'ASSIGN_TASK_REQUEST_ERROR',
    ASSIGN_TASK_REQUEST_STATUS: 'ASSIGN_TASK_REQUEST_STATUS',

    ADD_TASK_COMMENT_REQUEST: 'ADD_TASK_COMMENT_REQUEST',
    ADD_TASK_COMMENT_REQUEST_SUCCESS: 'ADD_TASK_COMMENT_REQUEST_SUCCESS',
    ADD_TASK_COMMENT_REQUEST_ERROR: 'ADD_TASK_COMMENT_REQUEST_ERROR',
    ADD_TASK_COMMENT_REQUEST_STATUS: 'ADD_TASK_COMMENT_REQUEST_STATUS'
}
